import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


const CustomerOrders = () => {
  const [orders, setOrders] = useState([]);
  const { isLoggedIn, user } = useSelector((state) => state.login);

  let apiUrl = '/';

  const navigate = useNavigate();

  if(process.env.REACT_APP_ENVIRONMENT == 'local'){
       apiUrl = process.env.REACT_APP_SERVER_API_URL;
  }

  useEffect(()=> {
    const fetchOrders = async () => {
      try {
        const response =  await axios.get(`${apiUrl}api/getuserorders/${user.id}`);
        setOrders(response.data);
      } catch (error) {
          console.log("error",error);
      }
    }
    if(isLoggedIn && user?.id){
      fetchOrders();
    }
    else{
      navigate('/');
    }
  },[isLoggedIn])

  const formatDate = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
  };
  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4">My Orders</h2>
      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead className="thead-dark">
            <tr>
              <th>#</th>
              <th>Order Number</th>
              <th>Transaction Id</th>
              <th>Order Date</th>
              <th>Total</th>
              <th>Products</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => (
              <React.Fragment key={order.id}>
                <tr>
                  <td>{index + 1}</td>
                  <td># {order.orderNumber}</td>
                  <td>{order.transactionId}</td>
                  <td>{formatDate(order.timestamp)}</td>
                  <td>
                    <span>
                      {order.basePrice} Eth
                    </span>
                  </td>
                  <td>
                    {order.items.map((product, idx) => (
                      <div key={idx}>
                        {product.name}  x {product.quantity} qty = {product.quantity * product.price} Eth
                      </div>
                    ))}
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CustomerOrders;
